import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import React, { useRef } from 'react';
import { MenuMaster, RoleMasterForm } from '../../../../models/role';
import {
    WorkflowRoleMasterForm,
    WorkflowRoleMasterFormRefHandle
} from './WorkflowRoleMasterForm';
import { WorkflowMenuMasterFormRefHandle } from '../../WorkflowMenuMasterConfig/components';

export type WorkflowRoleMasterFormModalProps = {
    title: string;
    isOpen: boolean;
    onClose: () => void;
    disabledKeyField?: boolean;
    defaultValues?: RoleMasterForm;
    onSubmit?: (formValues: RoleMasterForm) => void;
};

export const WorkflowRoleMasterFormModal = (
    props: WorkflowRoleMasterFormModalProps
) => {
    const {
        disabledKeyField,
        title,
        isOpen,
        onClose,
        defaultValues,
        onSubmit
    } = props;

    const formRef = useRef<WorkflowRoleMasterFormRefHandle>(null);

    const handleSaveClick = () => {
        const formValues = formRef.current?.submit();
        if (!formValues) {
            return;
        }

        onSubmit?.(formValues);
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
        >
            <ModalHeader toggle={onClose}>{title}</ModalHeader>
            <ModalBody>
                <WorkflowRoleMasterForm
                    ref={formRef}
                    disabledKeyField={disabledKeyField}
                    defaultValues={defaultValues}
                />
            </ModalBody>
            <ModalFooter className="flex justify-end">
                <Button
                    color="primary"
                    onClick={handleSaveClick}
                >
                    Save
                </Button>
                <Button
                    color="secondary"
                    onClick={onClose}
                    className="border-none bg-neutral-600"
                >
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};
